export const EventVisibilityType = {
  ANYONE: 'anyone',
  ANYONE_GUEST: 'anyone_as_guest',
  ORG_ONLY: 'tenant_open',
  INVITE_ONLY: 'invite_only'
};

export const eventVisibilityTypeFromString = (type) => {
  const lower = (type || '').toLowerCase();
  switch (lower) {
    case EventVisibilityType.ANYONE:
    case EventVisibilityType.ANYONE_GUEST:
    case EventVisibilityType.ORG_ONLY:
    case EventVisibilityType.INVITE_ONLY:
      return lower;
    default:
      throw Error(`Invalid event visibility type: ${type}`);
  }
};
